var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fill-height"},[_c('preloader'),_c('v-main',{staticClass:"fill-height"},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('router-view')],1)],1),_c('alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }